import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { CssBaseline } from "@mui/material"; // Add this import
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./redux/Store/Store";
import reportWebVitals from "./reportWebVitals";
import "typeface-roboto";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <CssBaseline />
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </>
);

reportWebVitals();
